import jwt_decode from "jwt-decode";

import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";
import BrowserPersistence from "web/utils/system/storage/storage/browserPersistence";

import storageNames from "web/constants/storageNames";
import { getToken } from "web/constants/urls";

import type { IStoredToken, IToken } from "web/types/Token";

import { request } from "web/api";

import clearStorageAndRedirectToLogin from "./clearStorageAndRedirectToLogin";

const storage = new BrowserPersistence();

let getTokenPromise: Promise<IToken | null> | null = null;
let storedToken: IStoredToken | null = null;
const OFFSET = 30000;
export default async (force = false) => {
  const location = window?.location?.pathname;

  const hasValidToken =
    !force && storedToken?.exp && storedToken.exp * 1000 > Date.now() - OFFSET;

  if (hasValidToken) {
    const { token, accessToken, idToken, ttl } = storedToken!;
    return {
      token,
      accessToken,
      ttl,
      idToken,
    };
  }

  try {
    const response = (await (getTokenPromise ??= request(getToken))) as IToken;
    getTokenPromise = null;

    const { success, token, accessToken, idToken } = response || {};
    if (success) {
      const { exp } = jwt_decode<{ exp: number }>(accessToken);
      const ttl = exp * 1000 - Date.now();

      storage.setItem(storageNames.token, null, token, ttl);
      storage.setItem(storageNames.tokenAccess, null, accessToken, ttl);
      storage.setItem(storageNames.idToken, null, idToken, ttl);

      window.dispatchEvent(new CustomEvent("tokenChange", { detail: { accessToken } }));

      storedToken = {
        token,
        accessToken,
        ttl,
        idToken,
        exp,
      };

      return {
        token,
        accessToken,
        ttl,
        idToken,
      };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    // removed new relic reporting for 401 in this request
    // as this is correct response if user is not logged in
    if (error?.response?.status !== 401) {
      newRelicErrorReport(
        error,
        "web-app/web/utils/system/essentials/getToken.js - 41"
      );
    }

    if (error?.response?.status === 401 && location !== "/sso/error") {
      clearStorageAndRedirectToLogin();
    }
    throw error;
  }
  return null;
};
